import React, { Component } from 'react'
import { withStore } from '../store'
import CloseUpSVG from '../../svg/CloseUpSVG'
import EditUpSVG from '../../svg/EditUpSVG'
import Table from '../Table'
import Loader from '../Loader'
import { Service } from '../ApiService'
import FixedWrapper from '../FixedWrapper'
import MultiDropDown from '../MultiDropDown/MultiDropDown'
import Alert from '../Alert'
import RadioButton from '../RadioButton'

import CheckBox from '../CheckBox'
import SearchInput from '../SearchInput'

//import { useHistory } from 'react-router-dom';

import { Helper } from '../Helper'
import { alertNotValid, showMessage } from '../alerts'
import InputWithClearButton from '../InputWithClearButton'


class MemberEventOrder extends Component {
    static displayName = MemberEventOrder.name;

    constructor(props) {
        super(props);
        props.store.refreshUserInfo();
        this.state = {
            order: {
                user: null,
                orderId: props.orderId,
                userEventId: props.userEventId,
                userId: '',
                orderServiceLines: [],
                amount: 0,
                discount: 0,
                gracePeriod: 0,
                card: '',
                createdDate: '',
                orderNumber: 0,
                paidDate: '',
                transactionId: ''
            },
            orderLineToEdit: null,
            loading: false,
            addingService: props.addingService != undefined ? props.addingService : false,
            tempService: {},
            tempServices: [],
            showMessage: false,
            showError: false
        };
        this.eventId = props.eventId;
        this.eventServiceLines = [];
        this.substractHeightElRef = null;
        this.modalWindowRef = null;
        this.membersDropDownRef = null;
        this.overridenPriceRef = null;
        this.removeService = this.removeService.bind(this);
        this.addService = this.addService.bind(this);
        this.checkout = this.checkout.bind(this);
        this.submitServicesToEvent = this.submitServicesToEvent.bind(this);
    }

    submitServicesToEvent = () => {
        this.setState({ loading: true }, () => {
            var linesToAdd = [];
            this.state.tempServices.map((value) => {
                linesToAdd.push({
                    userEventId: this.state.order.userEventId,
                    eventServiceLineId: value,
                    userEventOrderId: this.state.order.orderId
                });
            });
            Service.addOrderService(linesToAdd)
                .then(data => {
                    if (data.success === false) {
                        this.headerText = 'Failure';
                        this.dialogText = "Unable to save order";
                        this.dialogContent = <h4>{data.message}</h4>
                        this.mode = 'error'
                        this.setState({ loading: false, showMessage: true });
                        return Promise.reject(new Error(data.message));
                    }
                    else if (data.success === true) {
                        this.updateEventOrderProperties(data.data);
                    }
                    else
                        this.updateEventOrderProperties(data);
                });



            /*

            var lineToAdd = {
                userEventId: this.state.order.userEventId,
                eventServiceLineId: this.state.tempService,
                userEventOrderId: this.state.order.orderId
            };

            Service.addOrderService(lineToAdd)
                .then(data => {
                    if (data.success === false) {
                        this.headerText = 'Failure';
                        this.dialogText = "Unable to save order";
                        this.dialogContent = <h4>{data.message}</h4>
                        this.mode = 'error'
                        this.setState({ loading: false, showMessage: true });
                        return Promise.reject(new Error(data.message));
                    }
                    else if (data.success === true) {
                        this.updateEventOrderProperties(data.data);
                    }
                    else
                        this.updateEventOrderProperties(data);
                });
                */
        });
    }

    updateEventOrderProperties = (data) => {
        var order = { ...this.state.order };
        order.orderServiceLines = data.orderServiceLines;
        order.userId = data.userId;
        order.amount = data.amount;
        order.discount = data.discount;
        order.card = data.card;
        order.createdDate = data.createdDate;
        order.orderNumber = data.orderNumber;
        order.paidDate = data.paidDate;
        order.transactionId = data.transactionId;
        order.orderId = data.orderId;
        this.setState({
            order: order,
            loading: false,
            addingService: false,
            showPriceDialog: false,
            orderLineToEdit: null
        })
    }

    componentDidMount() {
        this.setState({ loading: true });
        Service.getEventSelectedServices(this.eventId)
            .then(data => {
                this.eventServiceLines = data;
                this.setState({
                    loading: false
                })
            });

        if (this.state.order && this.state.order.orderId) {
            Service.getMemberEventOrderById(this.state.order.orderId)
                .then(data => {
                    if (data.success === false) {
                        this.headerText = 'Failure';
                        this.dialogText = "Unable to load order services";
                        this.dialogContent = <h4>{data.message}</h4>
                        this.mode = 'error'
                        this.setState({ loading: false, showMessage: true });
                        return Promise.reject(new Error('Failed to load order services'));
                    }
                    else if (data.success === true) {
                        this.updateEventOrderProperties(data.data);
                    }
                    else this.updateEventOrderProperties(data);
                });
        }
    }

    addService = () => {
        this.setState({
            addingService: true
        });
    }

    checkout = () => {
        //let history = useHistory();
        //history.push('/order-checkout/' + this.state.order.orderId);
        this.props.history.push('/order-checkout/' + this.state.order.orderId);
    }

    removeService = (service) => {
        this.setState({ loading: true })
        var lineToRemove = {
            userEventId: this.state.order.userEventId,
            eventServiceLineId: service.eventServiceLineId,
            userEventOrderId: service.userEventOrderId,
            userEventOrderLineId: service.userEventOrderLineId
        };
        Service.deleteOrderService(lineToRemove)
            .then(data => {
                setTimeout(() => {
                    this.updateEventOrderProperties(data);
                }, 1000);
            });
    }

    saveOrderLinePrice = () => {
        this.setState({ loading: true }, () => {
            var modelLine = this.state.orderLineToEdit;
            let serviceLine = this.state.order.orderServiceLines.find(x => x.userEventOrderLineId === modelLine.userEventOrderLineId);
            serviceLine.overridenPrice = modelLine.overridenPrice ? modelLine.overridenPrice : 0;
            var thenFunc = (data) => {
                if (data.success === false) {
                    this.headerText = 'Failure';
                    this.dialogText = "Failed to update order line special price";
                    this.dialogContent = <h4>{data.message}</h4>
                    this.mode = 'error'
                    this.setState({ loading: false, showMessage: true });
                    //return Promise.reject(new Error('Failed to update order line special price'));
                }
                else if (data.success === true) {
                    this.updateEventOrderProperties(data.data);
                }
                else this.updateEventOrderProperties(data);
            }
            Service.updateOrderServiceSpecialPrice(serviceLine)
                .then(thenFunc);
        });
    }

    renderServiceName = (value, row, index, col) => {
        return (
            <li key={index} className={col.className ? "table-content " + col.className : "table-content"}>
                <span style={{ "flex": "1 1 auto" }} className="big-bold">{row.serviceName}</span>
                {this.props.editsPermitted !== false &&
                    <button
                        className='round-button small-round-button light-grey-outline-button'
                        style={{ "flex": "0 0 1rem", "marginLeft": "0.2em" }}
                        onClick={() => {
                            this.headerText = 'Warning';
                            this.dialogText = 'You want to remove the Service'
                            this.onOkButtonClick = () => { this.removeService(row); this.setState({ showDialog: false }) };
                            this.cancelButtonText = 'Cancel';
                            this.okButtonText = 'Remove';
                            this.dialogContent = <h4>{row.serviceName}</h4>
                            this.setState({ showDialog: true })/*this.removeMember(row)*/
                        }}
                    >
                        <CloseUpSVG />
                    </button>
                }
                {this.props.editsPermitted !== false && !row.transactionId && this.props.store.userInfo && this.props.store.userInfo.authType == "Admin" &&
                    <button
                        className='round-button small-round-button light-grey-outline-button'
                        style={{ "flex": "0 0 1rem", "marginLeft": "0.2em" }}
                        onClick={() => {
                            this.headerText = 'Special price for ' + row.serviceName;
                            this.setState({ orderLineToEdit: row, showPriceDialog: true });
                        }}>

                        <EditUpSVG />
                    </button>
                }
            </li>
        );
    }

    renderServiceDescription = (value, row, index, col) => {
        return (
            <li key={index} className={col.className ? "table-content " + col.className : "table-content"}>
                <span className='description-text'>{row.serviceDescription}</span>
            </li>
        );
    }

    renderPrice = (value, row, index, col) => {
        return (
            <li key={index} className={col.className ? "table-content " + col.className : "table-content"}>
                <div className='input-button-wrapper'>
                    {row.isPriceOverriden ?
                        <div style={{ flex: '1 0 auto' }}>
                            <span className='mr-075'><strong>Special price</strong></span>
                            <span>{Helper.CurrencyFormat(row.overridenPrice)}</span>
                        </div>
                        :
                        <div style={{ flex: '1 0 auto' }}>
                            <p>
                                <span className='mr-075'><strong>Standard price</strong></span>
                                <span>{Helper.CurrencyFormat(row.price)}</span>
                            </p>
                            {row.gracePrice != 0 &&
                                <p>
                                    <span className='mr-075'><strong>Advance Price</strong></span>
                                    <span>{Helper.CurrencyFormat(row.gracePrice)}</span>
                                </p>
                            }
                        </div>
                    }
                </div>
            </li>
        )
    }


    textPropertyRender(element, textProperty) {
        var serviceGroupName = this.props.store.serviceGroups.find(group => group.id == element['serviceGroup']).name;
        return <div style={{ display: 'flex' }}>
            <div style={{ flex: '0 1 auto' }}>
                <span className='group'>{serviceGroupName}</span>
                <span className='name'>{element["name"]}</span>
                <span className='description-text label-input-wrapper'>{element["description"]}</span>
                {/*</div>
            <div style={{ flex: '1 0 auto' }}>
                //<span>One time charge: {<strong>{Helper.CurrencyFormat(element["oneTimePrice"])}</strong>}</span>
                //{element["dailyPrice"] && element["dailyPrice"] != 0 ? <span>Daily charge: {<strong>{Helper.CurrencyFormat(element["dailyPrice"])}</strong>}</span> : ''}
                */}
            </div>
            <div style={{ flex: '1 0 auto' }}>
                <span><strong>{Helper.CurrencyFormat(element.price)}</strong></span>
            </div>
        </div>
    }

    //textPropertyRender(element, textProperty) {
    //    return <div style={{ display: 'flex' }}>
    //        <div style={{ flex: '0 1 auto' }}>
    //            <span className='name'>{element.service.name}</span>
    //            <span className='description-text label-input-wrapper'>{element.service.description}</span>
    //        </div>
    //        <div style={{ flex: '1 0 auto' }}>
    //            <span><strong>{Helper.CurrencyFormat(element.price)}</strong></span>
    //        </div>
    //    </div>
    //}

    onAddServiceWindowClose() {
        this.setState({ addingService: false })
    }

    getPanelToRender = () => {
        if (this.state.addingService) {
            return this.getAddServicePanel();
        }
        else {
            return this.getMainEventOrderPanel()
        }
    }

    getAddServicePanel = () => {
        return <FixedWrapper maxWidth={"600px"} noPadding={true}>
            <h2 className='ml-075 mr-075 mt-2 mb-1'>Add Services</h2>
            {/*<SearchInput
                placeholder='Search services'
                wrapperClassName='m-075'
                value={this.state.serviceFilter}
                onValueChange={(value) => {
                    clearTimeout(this.timeoutVar);
                    this.setState({ serviceFilter: value }, this.createFilteredListWithTimeOut());
                }}
                onClearValueButtonClick={() => {
                    clearTimeout(this.timeoutVar);
                    this.setState({ serviceFilter: "" }, this.createFilteredListWithTimeOut());
                }}
            />
            <div className='flex-wrap justify-space-between align-center mr-075 ml-05 mb-05'>
                <CheckBox
                    className='mr-1 mb-1 ml-025'
                    onClick={() => {
                        clearTimeout(this.timeoutVar); // ????
                        let services = [];
                        if (!this.state.selectAllCheckboxChecked) {
                            this.eventServiceLines.forEach(element => {
                                services.push(element.serviceLineId)
                            })
                        }
                        this.setState({
                            tempServices: services,
                            selectAllCheckboxChecked: !this.state.selectAllCheckboxChecked
                        }, this.createFilteredListWithTimeOut());
                    }}
                    checked={this.state.selectAllCheckboxChecked}
                    labelStyle={{ "fontSize": "0.9rem" }}
                    labelText={<span>Select All<strong>{" " + this.state.filteredList.length.toString()}</strong></span>}
                />
                <div className='flex-wrap justify-left'>
                    <CheckBox
                        className='mb-1 ml-025'
                        onClick={() => {
                            clearTimeout(this.timeoutVar);
                            this.setState({
                                selectedServicesOnlyChecked: !this.state.selectedServicesOnlyChecked
                            }, this.createFilteredListWithTimeOut())
                        }}
                        checked={this.state.selectedServicesOnlyChecked}
                        labelStyle={{ "fontSize": "0.9rem" }}
                        labelText={<span>Selected Only<strong>{" " + this.state.tempServices.length.toString()}</strong></span>}
                    />
                </div>
            </div>*/}
            {this.eventServiceLines.length === 0 && <p className='message-block mb-2 mt-2'>There are no services provided by the event.</p>}
            {this.eventServiceLines.length > 0 &&
                <MultiDropDown
                    className='pr-075'
                    customHeightCoeff={1.5}
                    list={this.eventServiceLines}
                    multiSelect={true}
                    toggleable={false}
                    keyProperty='eventServiceLineId'
                    textProperty='name'
                    defaultValue={this.state.tempServices}
                    placeholder="Select from the list"
                    onDropDownValueChange={value => this.setState({ tempServices: value })}
                    hideHeader={true}
                    substractHeight={65}
                    textPropertyRender={(element, textProperty) => this.textPropertyRender(element, textProperty)}
                />

            }
            <div className='flex-nowrap justify-center mt-1 mb-05 mr-075 ml-075'>
                <button ref={el => this.okButtonRef = el} className='medium-static-button static-button' onClick={this.submitServicesToEvent}>OK</button>
                <button ref={el => this.cancelButtonRef = el} className='medium-static-button static-button default-button' onClick={() => this.setState({ addingService: false, tempServices: [], serviceFilter: '' })}>Cancel</button>
            </div>
        </FixedWrapper>
    }

    getAddServiceDropDownPanel = () => {

        return <FixedWrapper maxWidth={"600px"} noPadding={true}>
            <h2 className='ml-075 mr-075 mt-2 mb-1'>Add Service</h2>
            <MultiDropDown
                list={this.eventServiceLines}
                keyProperty='eventServiceLineId'
                textProperty='name'
                defaultValue={this.state.tempService}
                placeholder="Select from the list"
                customHeightCoeff={3}
                textPropertyRender={(element, textProperty) => this.textPropertyRender(element, textProperty)}
                onDropDownValueChange={value => {
                    this.emptyType = false;
                    this.setState({ tempService: value })
                }}
            />
            {/*this.eventServiceLines.length > 0 &&
                <MultiDropDown
                    //className='pr-075'
                    list={this.eventServiceLines}
                    multiSelect={false}
                    //toggleable={true}
                    keyProperty='serviceLineId'
                    textProperty='name'
                    defaultValue={this.state.tempServices}
                    placeholder="Select from the list"
                    onDropDownValueChange={value => this.setState({ tempServices: value })}
                    hideHeader={true}
                    //substractHeight={65}
                    textPropertyRender={(element, textProperty) => this.textPropertyRender(element, textProperty)}
                />
            */}
            <div className='flex-nowrap justify-center mt-1 mb-05 mr-075 ml-075'>
                <button ref={el => this.okButtonRef = el} className='medium-static-button static-button' onClick={this.submitServicesToEvent}>OK</button>
                <button ref={el => this.cancelButtonRef = el} className='medium-static-button static-button default-button' onClick={() => this.setState({ addingService: false, tempServices: [] })}>Cancel</button>
            </div>
        </FixedWrapper>
    }



    getMainEventOrderPanel = () => {
        const orderServiceLines = this.state.order.orderServiceLines;

        const columns = [
            { title: "Service", accesor: "name", className: "borders-when-display-block", render: this.renderServiceName },
            { title: "", accesor: "description", className: "borders-when-display-block", render: this.renderServiceDescription },
            { title: "Price", accesor: "oneTimePrice", render: this.renderPrice },
        ];

        //

        return <div style={{ border: '1' }}>
            {orderServiceLines && orderServiceLines.length === 0 && <p className='message-block mb-2 pr-1 pl-1'>There are no services added to the order.</p>}
            {this.props.editsPermitted !== false &&
                <div className="flex-wrap align-center justify-center mb-2 pr-1 pl-1">
                    <button className='big-static-button static-button' onClick={this.addService}>Add Services</button>
                    {!this.state.order.transactionId && orderServiceLines.length > 0 && this.props.store.userInfo &&
                        (this.props.store.userInfo.userId == this.state.order.userId || this.props.store.userInfo.authType == "Admin") &&
                        <button className='big-static-button static-button' onClick={() => window.location = '/order-checkout/' + this.state.order.orderId}>Checkout</button>
                    }
                </div>
            }
            {orderServiceLines.length > 0 &&
                <div>
                    <ul className='input-fields first-child-text-240 mt-1 pl-1 pr-1'>
                        <li style={{ display: 'flex' }}>
                            <p>Order #{this.state.order.orderNumber}</p>
                            <p className='label'>{this.state.order.createdDate}</p>
                        </li>
                        <li>
                            <p className='input-label'>Calculated Projected Cost:</p>
                            <input
                                readOnly={true}
                                placeholder='$'
                                type='text'
                                value={'$' + this.state.order.amount}
                                style={{ "color": "rgb(0, 153, 204)", /*"borderColor":"#fcfcfc",*/ "backgroundColor": "#f4f3f2" }}
                            />
                        </li>
                        <li>
                            <p className='input-label'>Advance Payment Discount:</p>
                            <input
                                readOnly={true}
                                placeholder='$'
                                type='text'
                                value={'$' + this.state.order.discount}
                                style={{ "color": "rgb(0, 153, 204)", /*"borderColor":"#fcfcfc",*/ "backgroundColor": "#f4f3f2" }}
                            />
                        </li>
                        <li>
                            <p className='input-label'>Total Cost (before taxes):</p>
                            <input
                                readOnly={true}
                                placeholder='$'
                                type='text'
                                value={'$' + (this.state.order.amount - this.state.order.discount)}
                                style={{ "color": "rgb(0, 153, 204)", /*"borderColor":"#fcfcfc",*/ "backgroundColor": "#f4f3f2" }}
                            />
                        </li>
                    </ul>
                    <Table columns={columns} data={orderServiceLines} className={"break-at-500"} addHeadersForNarrowScreen={true} />
                </div>
            }
        </div>
    }

    render = () => {
        var me = this;
        var panel = this.getPanelToRender();
        return (
            <div className='w-100 prpl-0'>
                {this.state.loading && <Loader />}

                {panel}

                {this.state.showDialog &&
                    <Alert
                        headerText={this.headerText}
                        text={this.dialogText}
                        onClose={() => this.setState({ showDialog: false })}
                        showOkCancelButtons={true}
                        onCancelButtonClick={() => this.setState({ showDialog: false })}
                        onOkButtonClick={this.onOkButtonClick}
                        cancelButtonText={this.cancelButtonText}
                        okButtonText={this.okButtonText}
                        mode='warning'
                    >
                        {this.dialogContent}
                    </Alert>
                }

                {this.state.showPriceDialog &&
                    <Alert
                        headerText={this.headerText}
                        text='Update special service price for this vendor'
                        onClose={() => this.setState({ showDialog: false })}
                        showOkCancelButtons={true}
                        onCancelButtonClick={() => this.setState({ showPriceDialog: false })}
                        onOkButtonClick={() => { this.saveOrderLinePrice(); this.setState({ showPriceDialog: false }) }}
                        cancelButtonText='Cancel'
                        okButtonText='Save'
                        mode='warning'
                    >
                        <div className='mb-05'>
                            <RadioButton
                                style={{ "marginRight": "0.75rem" }}
                                radioGroupElement={this.state.orderLineToEdit}
                                radioButtonValue={this.state.orderLineToEdit.price}
                                onClick={(value) => {
                                    var orderLineToEdit = { ...this.state.orderLineToEdit };
                                    orderLineToEdit.overridenPrice = value;
                                    this.setState({ orderLineToEdit: orderLineToEdit});
                                }}
                                labelClassName="checkbox-text"
                                labelText={'Standard price: ' + Helper.CurrencyFormat(this.state.orderLineToEdit.price, true)}
                        />
                        {this.state.orderLineToEdit.gracePrice ?
                            <RadioButton
                                radioGroupElement={this.state.orderLineToEdit}
                                radioButtonValue={this.state.orderLineToEdit.gracePrice}
                                onClick={(value) => {
                                    var orderLineToEdit = { ...this.state.orderLineToEdit };
                                    orderLineToEdit.overridenPrice = value;
                                    this.setState({ orderLineToEdit: orderLineToEdit });
                                }}
                                labelClassName="checkbox-text"
                                labelText={'Advance price: ' + Helper.CurrencyFormat(this.state.orderLineToEdit.gracePrice, true)}
                            /> : ''
                        }
                        {this.state.orderLineToEdit.dailyPrice ?
                            <RadioButton
                                radioGroupElement={this.state.orderLineToEdit}
                                radioButtonValue={this.state.orderLineToEdit.dailyPrice}
                                onClick={(value) => {
                                    var orderLineToEdit = { ...this.state.orderLineToEdit };
                                    orderLineToEdit.overridenPrice = value;
                                    this.setState({ orderLineToEdit: orderLineToEdit });
                                }}
                                labelClassName="checkbox-text"
                                labelText={'Daily price: ' + Helper.CurrencyFormat(this.state.orderLineToEdit.dailyPrice, true)}
                            /> : ''
                        }
                        </div>
                        <InputWithClearButton
                            type='number'
                            ref={el => this.overridenPriceRef = el}
                            placeholder='Special price'
                            value={this.state.orderLineToEdit.overridenPrice ? this.state.orderLineToEdit.overridenPrice : ''}
                            onChange={e => {
                                var line = { ...this.state.orderLineToEdit };
                                line.overridenPrice = e.target.value;
                                this.setState({ orderLineToEdit: line })
                            }}
                            onClearValue={() => {
                                var line = { ...this.state.orderLineToEdit };
                                line.overridenPrice = null;
                                this.setState({ orderLineToEdit: line })
                            }}
                        />
                    </Alert>
                }

                {this.state.showMessage && showMessage(this.headerText, this.dialogText, this.dialogContent, this.mode, () => this.setState({ showMessage: false }))}


            </div>
        );
    }
}

export default withStore(MemberEventOrder)



// WEBPACK FOOTER //
// ./src/components/member/MemberEventOrder.jsx